export default __webpack_public_path__ + "static/media/empty-listing.34aef5e4.svg";